import api from '../../plugins/api';

const getStockReportStatus = (reportId) => {
  return api.get('/api/crm/cars/stockReport/status/' + reportId);
};

export default getStockReportStatus;
